module.exports = __webpack_public_path__ + "static/media/bar_chart_selected.9720f919.svg";